/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarpQuayInner
 */
export interface WarpQuayInner {
    /**
     * 
     * @type {string}
     * @memberof WarpQuayInner
     */
    name?: string;
}

/**
 * Check if a given object implements the WarpQuayInner interface.
 */
export function instanceOfWarpQuayInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WarpQuayInnerFromJSON(json: any): WarpQuayInner {
    return WarpQuayInnerFromJSONTyped(json, false);
}

export function WarpQuayInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarpQuayInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WarpQuayInnerToJSON(value?: WarpQuayInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

